import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class DcsMetricsService {

    constructor (private http: Http) {}

    getMetrics(): Observable<any> {
        return this.http.get('management/metrics').map((res: Response) => res.json());
    }

    threadDump(): Observable<any> {
        return this.http.get('management/dump').map((res: Response) => res.json());
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/metrics/metrics.service.ts